import {
  DirectSalesLineAllocation,
  DirectSalesState,
  DirectSalesCampaignDealLineResponse,
  DirectSalesAllocationSolutionResponse,
} from 'components/common/types/DirectSalesCampaign.types';
import { PERSISTED_STATUSES } from 'consts/campaignStatus';
import transformDirectSalesLineAllocation from './transformDirectSalesLineAllocation';

const buildLinesStatesWithAllocation = (
  savedDealLines: DirectSalesCampaignDealLineResponse[],
  allocationSolution: DirectSalesAllocationSolutionResponse | null,
  campaignId?: string,
): Record<string, { state: DirectSalesState; allocation: DirectSalesLineAllocation }> =>
  Object.fromEntries(
    savedDealLines.map((line) => {
      const lineState = PERSISTED_STATUSES.includes(line.status) ? { status: line.status } : line.state;
      const lineAllocation = transformDirectSalesLineAllocation(
        allocationSolution,
        lineState.status,
        line.id,
        campaignId,
      );
      return [line.id, { state: lineState, allocation: lineAllocation }];
    }),
  );

export default buildLinesStatesWithAllocation;
